import React, { useId } from 'react';
import PropTypes from 'prop-types';
import { ChevronDown } from 'lucide-react';
import './accordion.css';

/* Accordion — one collapsible group in the browse rail (`.br-grp`).

   Open/closed is a class and the body is hidden by CSS (`.br-grp.open .br-gb`),
   as in the reference, so a group's geometry is one rule rather than a branch in
   the markup.

   The children are only mounted while open, which is not the same thing: a
   collapsed group can hold a hundred facet rows nobody can see. The CSS still
   owns the hiding.

   It is controlled: the rail decides what is open, because the reference opens
   Category by default and opens a group the moment a deep link ticks something
   inside it. */
export default function Accordion({ title, isOpen, onToggle, children, className }) {
  const bodyId = useId();

  return (
    <div className={`br-grp${isOpen ? ' open' : ''}${className ? ` ${className}` : ''}`}>
      <button
        type="button"
        className="br-gh"
        onClick={onToggle}
        aria-expanded={!!isOpen}
        aria-controls={bodyId}
      >
        <span>{title}</span>
        <ChevronDown aria-hidden="true" />
      </button>
      <div className="br-gb" id={bodyId}>
        {isOpen && children}
      </div>
    </div>
  );
}

Accordion.propTypes = {
  title: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
};
